var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"fb-customerchat",attrs:{"id":"fb","attribution":"setup_tool","page_id":"128793543821467"}})}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-3f1aac75","hasScoped":true}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/Home/FbMessenger.vue
// module id = 447
// module chunks = 2